import { render, staticRenderFns } from "./ManagerWaitlistPage.vue?vue&type=template&id=3b2e01c2&scoped=true"
import script from "./ManagerWaitlistPage.vue?vue&type=script&lang=js"
export * from "./ManagerWaitlistPage.vue?vue&type=script&lang=js"
import style0 from "./ManagerWaitlistPage.vue?vue&type=style&index=0&id=3b2e01c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e01c2",
  null
  
)

export default component.exports